<template>
  <div class="sop-container">
    <MySearch
      :namePlaceholder="namePlaceholder"
      :KHSOPxbc="KHSOPxbc"
      @searchFn="searchFn"
      @selectTime="selectTime"
      @createSOP="createSOP"
    ></MySearch>
    <tableWrap>
      <template #table>
        <el-table
          size="medium"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          ref="returnVisitSOPTable"
          :height="
            namePlaceholder == '搜索SOP任务名称'
              ? 'calc(100vh - 289px)'
              : 'calc(100vh - 233px)'
          "
          :highlight-current-row="true"
          :data="tableData"
          style="width: 100%;font-size: 13px"
        >
          <el-table-column
            v-for="(item, index) in tableHeader"
            :key="item.id"
            :label="item.label"
            :prop="item.id"
            :min-width="item.minWidth"
            :align="item.align"
          >
            <template slot-scope="scope">
              <div v-if="namePlaceholder == '搜索SOP任务名称'">
                <div v-if="item.id != 'createMessage' && item.id != 'option'">
                  <div :class="item.id == 'content' ? 'content-col' : ''">
                    {{ scope.row[item.id] }}
                  </div>
                </div>
                <div v-if="item.id == 'createMessage'">
                  <div>
                    {{
                      scope.row.createByName +
                        " | " +
                        getTime(scope.row.createTime)
                    }}
                  </div>
                </div>
                <div v-if="item.id == 'option'">
                  <el-button
                    class="table-button"
                    type="text"
                    size="small"
                    @click.stop="handleDetail(scope.row.sopId, scope.row)"
                    >详情</el-button
                  >
                  <el-button
                    class="table-button"
                    type="text"
                    size="small"
                    v-if="KHSOPcd"
                    @click.stop="
                      handleData(scope.row.sopId, scope.row.sopName, scope.row)
                    "
                    >数据</el-button
                  >
                  <el-button
                    class="table-button"
                    type="text"
                    size="small"
                    v-if="KHSOPxbc && namePlaceholder == '搜索SOP任务名称'"
                    @click.stop="handleDel(scope.row.sopId)"
                    >删除</el-button
                  >
                </div>
              </div>
              <div v-else>
                <div v-if="item.id == 'msgName'">
                  <span v-if="scope.row.status == -1" style="color:#F56C6C"
                    >【处理失败】</span
                  >{{ scope.row[item.id] }}
                </div>
                <div
                  v-else-if="
                    item.id == 'empNumDone' || item.id == 'empNumNoDone'
                  "
                >
                  <div>
                    {{ scope.row.status == 0 ? scope.row[item.id] : "-" }}
                  </div>
                </div>
                <div v-else-if="item.id == 'createMessage'">
                  <div>
                    {{
                      scope.row.createByName +
                        " | " +
                        getTime(scope.row.createTime)
                    }}
                  </div>
                </div>
                <div v-else-if="item.id == 'option'">
                  <div v-if="scope.row.status == -1">
                    <span>数据处理失败，请重新创建该群发</span>
                  </div>
                  <div v-else>
                    <el-button
                      class="table-button"
                      type="text"
                      size="small"
                      @click.stop="handleDetail(scope.row.sopId, scope.row)"
                      >详情</el-button
                    >
                    <el-button
                      class="table-button"
                      type="text"
                      size="small"
                      v-if="KHSOPcd"
                      @click.stop="
                        handleData(
                          scope.row.sopId,
                          scope.row.sopName,
                          scope.row
                        )
                      "
                      >数据</el-button
                    >
                  </div>
                </div>
                <div v-else>
                  <div :class="item.id == 'content' ? 'content-col' : ''">
                    {{ scope.row[item.id] }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template #pagination>
        <Pagination
          v-bind:childMsg="pageparm"
          :pageSizes="pageSizes"
          @callBack="callBack"
        ></Pagination>
      </template>
    </tableWrap>
  </div>
</template>
<script>
import tableWrap from "@/components/tabelWrap.vue";
import MySearch from "@/views/mass/SOP/components/search.vue";
import { timeFormat } from "@/utils/common.js";
export default {
  name: "commonSOP",
  components: {
    tableWrap,
    MySearch,
  },
  props: {
    tableHeader: {
      type: Array,
      default: () => [],
    },
    pageparm: {
      type: Object,
      default: () => ({
        currentPage: 1,
        pageSize: 20,
        total: 0,
      }),
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    namePlaceholder: {
      type: String,
      default: "搜索SOP任务名称",
    },
    // 可新建/编辑/删除
    KHSOPxbc: {
      type: Boolean,
      default: false,
    },
    // 可查看/导出数据
    KHSOPcd: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchSelectTime: [],
      // pageparm: {
      //   currentPage: 1,
      //   pageSize: 20,
      //   total: 0,
      // },
      getDataParams: {
        sopName: "",
        startTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 20,
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
    };
  },
  created() {},
  watch: {},
  computed: {},
  methods: {
    selectTime(value) {
      console.log("valuecommon", value);
      this.searchSelectTime = value;
      if (value != null) {
        this.getDataParams.startTime = value[0];
        this.getDataParams.endTime = value[1];
      } else {
        this.getDataParams.startTime = "";
        this.getDataParams.endTime = "";
      }
      this.$emit("reGet", this.getDataParams);
    },
    searchFn(val) {
      this.getDataParams.sopName = val;
      this.$emit("reGet", this.getDataParams);
    },
    createSOP() {
      this.$emit("createSOP");
    },
    callBack(parm) {
      this.getDataParams.pageNum = parm.currentPage;
      this.getDataParams.pageSize = parm.pageSize;
      this.$emit("reGet", this.getDataParams);
    },
    handleDel(sopId) {
      this.$emit("handleDel", sopId);
    },
    handleDetail(sopId, row) {
      this.$emit("handleDetail", sopId, row);
    },
    handleData(sopId, sopName, row) {
      this.$emit("handleData", sopId, sopName, row);
    },
    /** 格式化时间 */
    getTime(time) {
      console.log("time+++", time);
      console.log("timeFormat+++", timeFormat);
      return timeFormat(time, "yyyy-mm-dd hh:MM:ss");
    },
  },
};
</script>
<style lang="scss" scoped>
.sop-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  .content-col {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  // /deep/ .el-table__body-wrapper {
  //   overflow-y: scroll;
  // }
}
</style>
